module.exports = __webpack_public_path__ + "img/logo_footer.ec9190da.svg";